import {
    Flex,
    Box, 
    Text,
    Image,
    Button,
    Input,
    useToast,
    Radio
} from '@chakra-ui/react'
import React, { useEffect, useState, useRef } from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import useApp from '../context/AppContext'
import Player from './Player'
import db from '../firebase'
import { setDoc, doc, updateDoc } from 'firebase/firestore'
import useAuth from '../context/AuthContext'




function Players() {

    const [params] = useSearchParams()
    const cat = params.get('cat')
    const {players, soldPlayers, reservedPlayers} = useApp()
    const {user} = useAuth()
    const [catPlayer, setCatPlayers] = useState([])
    const [search, setSearch] = useState("")
    const [newCat, setCat] = useState(cat)

    const [selected, setSelected] = useState({
        select: false,
        players: []
    })

    const toast = useToast()
    const navigate = useNavigate()

    const printCat = () => navigate({
        pathname:'/printplayers',
        search: `?cat=${cat}`   
    })

    const updateSelected = (pid) => {
        if(selected.players.includes(pid))
            setSelected({
                select: true,
                players: selected.players.filter(s => s !== pid)
            })
        else
            setSelected({
                select: true,
                players: [...selected.players, pid]
            })
    }

    const selectAll = () => {
        if(selected.players.length === catPlayer.length)
            setSelected({
                select: true,
                players: []
            })
        else
            setSelected({
                select: true,
                players: catPlayer.map(c => c.pid)
            })
    }

    const updateCat = async () => {
        if(newCat.length < 1 || newCat === cat)
        {
            toast({
                position: 'bottom-right',
                title: `Invalid Category`,
                status: `error`,
                duration: 1000,
                isClosable: true,
            })
            return
        }

        console.log("Working")
        for(let player of selected.players) {
            
            console.log(player)
            if(player)
            await updateDoc(doc(db, 'players', player), {
                category: newCat
            })
        }

        toast({
            position: 'bottom-right',
            title: `Category Updated Successfully`,
            status: `success`,
            duration: 1000,
            isClosable: true,
        })
    }

    useEffect(() => {
        
        if(players?.list?.length > 0)
        {
            let plays = []
            players?.list?.map(p => {
                
                if(players?.players[p]?.category === cat)
                {
                    if(soldPlayers?.filter(s => s.pid === p).length === 0)
                        plays.push(players.players[p])
                }
    
            })
            // console.log(plays)

            setCatPlayers([...plays])

        }

    }, [players, params, soldPlayers])

    return (
        <Flex direction={'column'}>
            <Flex
                direction={'row'}
                justifyContent="space-between"
                px={10}
                py={2}
            >
                <Flex>Category: {cat}</Flex>
                <Flex>Players Left: {catPlayer.length}</Flex>
                <Button onClick={() =>printCat()}>Print</Button>
            </Flex>

            <Input
                placeholder='Search Player'
                maxW={'80%'}
                mx={'auto'}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            <Flex
                justifyContent={'center'}
                direction={'row'}
                wrap={'wrap'}
                mx={'auto'}
                p={3}
                gap={3}
            >
                {user && <>
                <Input 
                    placeholder='New Category'
                    value={newCat}
                    length={1}
                    width={20}
                    onChange={(e) => setCat(e.target.value)}/>
                <Button onClick={() => updateCat()}>Update</Button>
                <Button onClick={() => setSelected({select: !selected.select, players: []})}>{selected.select?"Clear":"Select"}</Button>
                <Button onClick={() => selectAll()}>Select All</Button>
                </>}

                </Flex>
                {
                    user && selected.select?
                    <Flex
                    position={'fixed'}
                    top={10}
                    right={10}
                    zIndex={10}
                    width={200}
                    length={200}
                    bg={'gray.700'}
                    direction={'column'}
                    p={3}
                    borderRadius={10}
                    >
                    <Text>Selected: {selected.players.length}</Text>

                    {selected.players.map(p => <Text>{players.players[p].name}</Text>)}

                </Flex>
                :<></>}
                
                <Flex
                    direction={'column'}
                    gap={3}
                    px={5}
                    mt={5}
                >

            {catPlayer.length > 0?catPlayer.map(c => {
                
                const reserve = reservedPlayers.filter(r => r.pid === c.pid)[0]
                
                if(search.trim().length > 0)
                    if(!players.players[c.pid].num.toLowerCase().includes(search.toLowerCase()))
                        return <></>

                return (
                    <Flex 
                        alignItems={'center'}
                        gap={2}
                    >
                        <Flex>

                            <Button 
                                onClick={()=>updateSelected(c.pid)}
                                bg={selected.players.includes(c.pid)?'cyan.600':'gray.700'}
                            >
                            <Text>{players.players[c.pid].num}</Text>
                            </Button>
                        </Flex>
                        <Player data={c} reserved={reserve?reserve:null}/>
                    </Flex>
            )}):<>No Players Left in This Catogory</>}
            </Flex>
        </Flex>
    )
}

export default Players

